import { type SalesMetricV2 } from "./types";

export function makeTradedeskImpressions(): SalesMetricV2 {
  const id = "tradedeskImpressions";
  const name = "Trade Desk Impressions";

  return {
    id,
    name,
    fullName: name,
    description: "Trade Desk Impressions",
    category: "tradedesk",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}
